import formatDecimal from "./formatDecimal";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-format/src/exponent.js
// module id = ../../../../d3-format/src/exponent.js
// module chunks = 4